import { isDeepEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as routeBound from '../../../route-bound'
import type { Feature } from '../feature'

/**
 * Loads the survey configuration when the scenario context changes. If the
 * scenario context is not available, it clears the survey configuration.
 */
export const loadOnScenarioContextChange = store.effects.create(
  (feature: Feature, context$: routeBound.scenario.Context.Stream) =>
    context$.pipe(
      rxjs.distinctUntilChanged(isDeepEqual),
      rxjs.map(context =>
        TypeChecker.isNotNullish(context)
          ? feature.actions.load
              .from('loadOnScenarioContextChange.ContextAvailable')
              .create()
          : feature.actions.clear
              .from('loadOnScenarioContextChange.ContextUnavailable')
              .create(),
      ),
    ),
)
